module.exports = __webpack_public_path__ + "static/media/leading.415926ae.png";